<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vYRGVM/Images/cover.jpg" alt="This image is the cover for the book Tory Roof"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tory Roof
      </h1>
      <p class="bookDescription body article font2">
        <p>TORY ROOF is a woman’s story – an unexpected romance and account of bravery – that pits logic against longing. The story takes Sarah Sutherland from the safety of her contemporary New England home into the arms of a fiery Revolutionary War agitator. In the process, she discovers her own independence and why she was chosen to traverse time. The present-day plot unfolds throughout the course of a year and dovetails with actual events in 1765. In trying to reconcile her two realities, Sarah learns that the people around her are not as they seem and that her life is in danger.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jill C. Baker
      </h2>
      
      <p class="authorDescription body article"><p>Jill C. Baker grew up in a small town in New York state where, as a teenager, she wrote a weekly newspaper column and reviewed summer stock theater. She pursued her interest in media and writing at Boston University&rsquo;s College of Communication. Upon graduation, she moved to Southern California to work in the film production. With a relocation to San Francisco and eventually back to Boston, she returned to her newspaper roots, serving as a copywriter and promotion manager for leading publishers such as Hearst and Harte-Hanks. Following a detour into the non-profit sector, she became Director of Marketing for a digital publishing provider in the magazine industry. Constantly facing deadlines and rigorous commutes, she often wondered what it would be like to simply disappear and do something else&mdash;thus the motivation for the Sutherland Series. She and her husband live in New England where they&rsquo;ve raised two sons and several cats. The rich historic setting provides valuable inspiration.</p></p>
      
      
         <a class="authorURL body link" href="http://www.jillcbakerauthor.com" target="_blank">
      
              About Author
         </a>
         <br/>
      
         <a class="authorURL body link" href="https://www.facebook.com/jill.baker.7393" target="_blank">
      
              More  About Author
         </a>
         <br/>
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sudbury Publishing Group
     </h2>
        
            <p class="publisherDescription body article"><p>Sudbury Publishing Group is a small company catering to those interested in self-publishing for personal or public enjoyment. SPG specializes in eclectic subjects, family histories, photography compendiums, and now, trade books.</p></p>
        
        
     <a class="publisherURL body link" href="http://www.sudburypublishinggroup.com" target="_blank">
  
          About Publisher
     </a>
     <br/>
  
     <a class="publisherURL body link" href="mailto:info@sudburypublishinggroup.com" target="_blank">
  
          More  About Publisher
     </a>
     <br/>
  
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23e504e0